import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import { AuthProvider } from "@/context/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { SpecSchemaProvider } from "@/context/SpecSchemaContext";
import { RequireRole } from "@/components/DashboardShell";
import Home from "@/pages/Home";
import HomePlanB from "@/pages/HomePlanB";
import Search from "@/pages/Search";
import ProductDetail from "@/pages/ProductDetail";
import Rfq from "@/pages/Rfq";
import HowItWorks from "@/pages/HowItWorks";
import Pricing from "@/pages/Pricing";
import SupplierJoin from "@/pages/SupplierJoin";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import BuyerPortal from "@/pages/BuyerPortal";
import SupplierPortal from "@/pages/SupplierPortal";
import AdminPortal from "@/pages/AdminPortal";
import { PaymentCancel, PaymentSuccess } from "@/pages/PaymentResult";
import AcceptInvite from "@/pages/AcceptInvite";
import GetHelp from "@/pages/GetHelp";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Faqs from "@/pages/Faqs";

export default function App() {
  return (
    <AuthProvider>
      <CurrencyProvider>
        <SpecSchemaProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePlanB />} />
            <Route path="/plan-b" element={<Navigate to="/" replace />} />
            <Route path="/classic-home" element={<Home />} />
            <Route path="/search" element={<Search />} />
            <Route path="/cross-reference" element={<Navigate to="/search" replace />} />
            <Route path="/products/:id" element={<ProductDetail />} />
            <Route path="/rfq" element={<Rfq />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/join-supplier" element={<SupplierJoin />} />
            <Route path="/suppliers" element={<Navigate to="/join-supplier" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/invite" element={<AcceptInvite />} />
            <Route path="/get-help" element={<GetHelp />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/faqs" element={<Faqs />} />
            <Route path="/faq" element={<Navigate to="/faqs" replace />} />
            <Route path="/support" element={<Navigate to="/get-help" replace />} />
            <Route path="/buyer/*" element={<RequireRole role="buyer"><BuyerPortal /></RequireRole>} />
            <Route path="/supplier/*" element={<RequireRole role="supplier"><SupplierPortal /></RequireRole>} />
            <Route path="/admin/*" element={<RequireRole role="admin"><AdminPortal /></RequireRole>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
        </SpecSchemaProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
}
